export const APPROVAL = 'approval';
export const QUOTE = 'quote';
export const SOLD = 'sold';
export const BOOKED = 'booked';
export const DELIVERED = 'delivered';
export const CANCELED = 'canceled';
export const DELETED = 'deleted';

export default {
    APPROVAL,
    QUOTE,
    SOLD,
    BOOKED,
    DELIVERED,
    CANCELED,
    DELETED,
};
